import { render, staticRenderFns } from "./author-view-works.vue?vue&type=template&id=7c7dcd4f&"
import script from "./author-view-works.vue?vue&type=script&lang=js&"
export * from "./author-view-works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports